<template>
  <div class="addMember">
    <el-dialog
      :title="title"
      :visible.sync="show"
      :modal-append-to-body="false"
      width="667px"
      style="margin-top:0vh;"
      class="welcomeDia treeDia"
      :close-on-click-modal="false"
      @close="closeTree"
    >
      <div class="data-wrap" v-if="!openOrCloseStatus">
        <div class="tree-wrap">
          <div class="head-left">
            <el-input
              placeholder="搜索成员"
              suffix-icon="el-icon-search"
              size="mini"
              v-model="filterText"
              clearable
              class="search-input"
            ></el-input>
          </div>
          <div class="tree-data">
            <el-tree
              :data="treeData"
              check-strictly
              v-loading="loading"
              :filter-node-method="filterNode"
              @check="treeCheck"
              ref="codeTree"
              show-checkbox
              node-key="id"
              :default-expanded-keys="defaultShowNodes"
              :expand-on-click-node="true"
              :render-after-expand="false"
            >
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <i>
                  <img
                    class="icon-style"
                    v-if="data.hasChildren"
                    src="@/assets/staffTree/department.png"
                    alt=""
                  />
                  <img
                    class="icon-style"
                    v-else
                    src="@/assets/staffTree/staff.png"
                    alt=""
                  />
                </i>
                <div
                  class="node-item"
                  :title="
                    data.hasChildren ? data.departmentName : data.userName
                  "
                >
                  <span class="content">{{
                    data.hasChildren ? data.departmentName : data.userName
                  }}</span>
                </div>
                <i v-if="data.hasChildren">
                  <img
                    class="btn-icon"
                    :class="node.expanded ? 'btn-icon2' : ''"
                    src="@/assets/staffTree/arrow.png"
                    alt=""
                  />
                </i>
              </div>
            </el-tree>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="selected-wrap" id="selectedWrap">
          <div class="old-select-wrap" v-if="oldSelectTitle">
            <div class="selected-title">{{ oldSelectTitle }}</div>
            <div class="selet-name-wrap">
              <div
                v-for="(item, index) in toBeReplaced"
                :key="index"
                class="select-right"
              >
                <span class="name-left">
                  <img
                    class="icon-style"
                    src="@/assets/staffTree/staff.png"
                    alt=""
                  />
                  <span class="select-name" :title="item.name">{{
                    item.name
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="select-wrap">
            <div class="selected-title">
              {{ currentSelectTitle ? currentSelectTitle : "已选成员" }}
            </div>
            <div class="selet-name-wrap">
              <div
                v-for="(item, index) in currentIdName"
                :key="index"
                class="select-right"
              >
                <span class="name-left">
                  <img
                    class="icon-style"
                    src="@/assets/staffTree/staff.png"
                    alt=""
                  />
                  <span class="select-name" :title="item.name">{{
                    item.name
                  }}</span>
                </span>
                <i class="el-icon-close" @click="clickCurrrntFn(item)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-wrap" v-if="openOrCloseStatus">
        <div class="tip">
          所有员工皆有账号许可权限，故没有可以继承账号许可的员工
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeTree">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="clickSubmit"
          :disabled="btnDisable"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getOrganization } from "@/api/staffTree/staffTree.js";
export default {
  name: "myStaffTree2",
  // selectNum: 限制所选数量,currentSelectMember:默认所选成员，title：弹框标题，oldSelectTitle:当前选中成员的标题，currentSelectTitle:所选成员的标题,toBeReplaced:待更换成员 treeType: 2的时候为非停用，如新建活码的单选成员，其他为停用
  props: [
    "dialogVisibleTree",
    "currentSelectMember",
    "toBeReplaced",
    "selectNum",
    "title",
    "oldSelectTitle",
    "currentSelectTitle",
    "treeType",
  ],
  data() {
    return {
      loading: false,
      show: false,
      filterText: "",
      data: [],
      treeData: [],
      staffList: [],
      serarchState: false,
      defaultProps: {
        id: "id",
        children: "children",
        label: "departmentName",
      },
      defaultShowNodes: [1], //树形默认展开节点编号
      currentMember: [], // 已选成员 原始数据
      currentIdName: [], // 已选成员名字 右侧显示
      selectAllValue: [],
      openOrCloseStatus: false,
    };
  },
  created() {
    this.getLicenseDepartStaff();
  },
  computed: {
    btnDisable() {
      let flag;
      if (this.currentIdName.length != 0) {
        flag = false;
      } else {
        flag = true;
      }
      return flag;
    },
  },
  watch: {
    async dialogVisibleTree(val) {
      if (val) {
        this.currentIdName = [];
        this.staffList = [];
        this.treeData = [];
        this.show = val;
        let tree2;
        if (this.treeType == 2) {
          // 非停用，比如新建活码单人选择
          tree2 = this.$store.state.tagsView.tree1;
        } else {
          tree2 = this.$store.state.tagsView.tree2;
        }
        // if (tree2 && tree2.length != 0) {
        //   this.staffList = tree2.empList;
        //   this.treeData = tree2.departEmpTrees;
        // } else {
          await this.getLicenseDepartStaff();
        // }
        this.$nextTick(() => {
          if (this.$refs.codeTree) {
            this.filterText = "";
            this.$refs.codeTree.setCheckedKeys([]);
            this.currentMember = this.currentSelectMember;
            setTimeout(() => {
              this.$refs.codeTree.setCheckedNodes(this.currentSelectMember);
              if (this.currentSelectMember.length != 0) {
                //整理右侧列表数据
                this.selectAllValue = [];
                this.getRightData(this.currentSelectMember);
              }
              this.defaultShowNodes = [1];
            }, 0);
            this.$refs.codeTree.setCheckedNodes(this.currentSelectMember);
          }
        });
      } else {
        this.show = false;
      }
    },
    filterText(val) {
      this.$refs.codeTree.filter(val);
    },
  },
  methods: {
    // 获取数据
    async getLicenseDepartStaff() {
      let params = {
        mark: this.treeType == 2 ? 2 : 1,
      };
      this.loading = true;
      let res = await getOrganization(
        params,
        localStorage.getItem("Authorization"),
        true
      );
      console.log("asjdlkjaslkdjlasjdlkajsldkjalksdj");
      if (res.error.code == 200) {
        if (this.treeType == 2) {
          this.$store.dispatch("tagsView/setTree1", res.data);
        } else {
          this.$store.dispatch("tagsView/setTree2", res.data);
        }
        this.loading = false;
        this.staffList = res.data.empList;
        this.treeData = res.data.departEmpTrees;
        this.openOrCloseStatus = res.data.openOrCloseStatus;
      }
      return;
    },
    filterNode(value, data) {
      if (!value) return true;
      if (data.departmentName && data.departmentName != null) {
        return false;
      } else {
        return data.userName.indexOf(value) !== -1;
      }
    },
    treeCheck(data, list) {
      //data 该节点所对应的对象、list 树目前的选中状态对象
      //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点
      //单选实现
      if (list.checkedKeys.length > 0) {
        let otherTargetArr = [];
        this.staffList.forEach((v) => {
          if (v.userId == data.userId) {
            otherTargetArr.push(v.id);
          }
        });
        if (otherTargetArr.length != 0) {
          //单选实现
          this.$refs.codeTree.setCheckedKeys(otherTargetArr);
        }
      } else {
        //取消当前选中节点
        this.$refs.codeTree.setCheckedKeys([]);
      }
      //选中的节点数据
      let checkedNodes = this.$refs.codeTree.getCheckedNodes();
      this.currentMember = checkedNodes;
      //整理右侧列表数据
      this.getRightData(this.currentMember);
    },
    //获取右侧列表的数据
    getRightData(data) {
      this.currentIdName = [];
      let memberList = data;
      memberList.map((v) => {
        this.currentIdName.push({
          treeId: v.id, //树id
          id: v.userId ? v.userId : v.departmentId,
          name: v.userName ? v.userName : v.departmentName,
          type: v.userId ? "per" : "depart",
        });
      });
      this.currentIdName = this.getArrSet(this.currentIdName, "id");
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
        return setArr;
      }, []);
      return arrays;
    },
    clickSubmit() {
      // 所选所有成员，去重
      let sendArray = this.allStaff();
      let obj = {
        sendArray: sendArray,
        currentIdName: this.currentIdName,
        currentMember: this.currentMember,
      };
      this.$emit("clickSubmitTree", obj);
    },
    allStaff() {
      // let arr = JSON.parse(JSON.stringify(this.currentMember))
      let arr = [];
      let that = this;
      return deepOperate(that.currentMember);
      function deepOperate(strArr) {
        strArr.forEach((item) => {
          if (item.hasChildren) {
            // arr = [...arr,...item.children]
            deepOperate(item.children);
          } else {
            arr.push(item);
          }
        });
        arr = that.getArrSet(arr, "userId");
        console.log("arr", arr);
        return arr;
      }
    },
    closeTree() {
      this.$emit("closeTree", false);
    },
    // item:删除的数据，flag: true 父组件调用，false：自己调用
    async clickCurrrntFn(item, flag) {
      //删除部门
      this.currentIdName = this.currentIdName.filter((v) => {
        return v.id != item.id;
      });
      this.currentMember = this.currentMember.filter((v) => {
        return v.departmentId != item.id && v.userId != item.id;
      });
      if (item.type == "depart") {
        this.$refs.codeTree.setChecked(item.treeId, false, true);
      } else {
        //删除员工
        //获取同userId的叶子节点
        let otherTargetArr = this.staffList.filter((v) => {
          return v.userId == item.id;
        });
        otherTargetArr.map((v) => {
          this.$refs.codeTree.setChecked(v.id, false, true);
        });
      }
      if (flag) {
        await this.getRightData(this.currentMember);
        this.clickSubmit();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.addMember {
  /deep/ .el-dialog__header {
    padding: 28px 32px 26px;
  }
  /deep/.el-dialog__body {
    padding: 0 28px 0 32px;
  }
  /deep/ .el-dialog__footer {
    padding: 14px 11px 24px 11px;
  }
  .head-wrap {
    align-items: center;
    display: flex;
    .head-left {
      flex: 1;
      margin-bottom: 20px;
      .search-input {
        width: 100%;
      }
    }
    .head-right {
      flex: 1;
      text-align: left;
      .selected-title {
        font-weight: 600;
        font-size: 16px;
        padding-left: 20px;
      }
    }
  }
  .data-wrap {
    display: flex;
    .tree-wrap {
      flex: 1;
      height: 376px;
      display: flex;
      flex-direction: column;
      .head-left {
        margin-bottom: 20px;
      }
      .tree-data {
        flex: 1;
        overflow: auto;
        padding-right: 5px;
        /deep/.el-loading-parent--relative {
          height: 100%;
        }
        &::-webkit-scrollbar {
          width: 3px;
          height: 8px;
          background-color: white;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(204, 204, 204, 0.3);
          border-radius: 5px;
          position: relative;
        }
      }
      .el-tree {
        /deep/.el-tree-node__content {
          position: relative;
        }
      }
      /deep/ .el-tree-node {
        .is-leaf + .el-checkbox .el-checkbox__inner {
          display: inline-block;
        }
        .el-checkbox .el-checkbox__inner {
          display: none;
        }
      }
    }
    .split-line {
      width: 0;
      border-left: 1px solid rgba(238, 239, 243, 1);
      margin: 0 31px 0 44px;
      position: relative;
      .line {
        position: absolute;
        width: 0;
        right: 0;
      }
    }
    /deep/.el-tree-node__content {
      &:hover {
        background-color: transparent;
      }
    }
    /deep/.el-tree-node.is-current > .el-tree-node__content {
      background-color: transparent;
    }
    .selected-wrap {
      flex: 1;
      height: 376px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .old-select-wrap {
        height: 100px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        .selet-name-wrap {
          flex: 1;
          overflow: auto;
        }
      }
      .select-wrap {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        .selet-name-wrap {
          flex: 1;
          overflow: auto;
          &::-webkit-scrollbar {
            width: 3px;
            height: 8px;
            background-color: white;
          }
          &::-webkit-scrollbar-thumb {
            background-color: rgba(204, 204, 204, 0.3);
            border-radius: 5px;
            position: relative;
          }
        }
      }
      .selected-title {
        font-weight: 400;
        font-size: 14px;
        margin-bottom: 20px;
      }
      .select-right {
        display: flex;
        justify-content: space-between;
        padding: 6px 5px 6px 3px;
        font-size: 15px;
        font-weight: bold;
        overflow: auto;
        &:hover {
          background-color: #f0f7ff;
        }
        .name-left {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon-style {
          width: 15px;
          height: 13px;
          margin-right: 5px;
        }
        .select-name {
          font-weight: 500;
          font-size: 12px;
          margin-left: 2px;
          // width: 100%;
          color: rgba(68, 68, 68, 0.85);
        }
        .el-icon-close {
          font-size: 15px;
          cursor: pointer;
        }
      }
    }
    .welcomeDia {
      .el-dialog__body {
        min-height: 200px;
        margin: 20px 20px;
        padding: 0px !important;
      }

      /deep/.el-dialog__footer {
        text-align: right;
      }
    }
    .treeDia {
      .el-dialog__body {
        min-height: 400px;
      }
    }
    .custom-tree-node {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      font-size: 12px;
      .icon-style {
        width: 15px;
        height: 13px;
        margin-right: 5px;
      }
      .node-item {
        flex: 1;
        width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .btn-icon {
        // transition: all 0.5s;
        transform: rotate(0);
        width: 14px;
        height: 14px;
        transition: transform 0.3s ease-in-out;
      }
      .btn-icon2 {
        transform: rotate(90deg);
      }
      .node-item {
        z-index: 9999;
      }

      .disable-cover {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.04) !important;
        top: 0;
        left: 0;
        z-index: 0;
        // cursor: not-allowed;
      }
    }

    /deep/.el-tree-node__content > .el-tree-node__expand-icon {
      display: none;
    }

    .node-disable {
      width: 100%;
      padding: 2px 0;
      color: rgba(0, 0, 0, 0.4);
      cursor: not-allowed;
    }
  }
  .empty-wrap {
    height: 376px;
    display: flex;
    justify-content: center;
    align-items: center;
    .tip {
      color: #333;
      font-size: 15px;
    }
  }

  /deep/.el-tree-node:focus > .el-tree-node__content {
    background-color: #fff !important;
  }
}
</style>
